import { setAuthorization, TokenManager } from "helpers/api_helper";
import {
  postJwtLogin,
  postAffiliateLogin,
} from "../../../helpers/backend_helper";
import { fetchVendorActivePropertyStatus } from "../../vendor/thunks";

import {
  loginRequest,
  loginSuccess,
  logoutUserSuccess,
  apiError,
  reset_login_flag,
} from "./reducer";

export const loginUser = (user: any, history: any, rememberMe: boolean = false) => async (dispatch: any) => {
  dispatch(loginRequest());

  try {
    const response = await postJwtLogin({
      email: user.email,
      password: user.password,
    });

    if (response && response.token) {
      TokenManager.setTokens(response, rememberMe);
      setAuthorization(response.token);
      dispatch(loginSuccess(response));

      // after login, call active-status endpoint to decide redirect
      try {
        const statusResult: any = await dispatch(fetchVendorActivePropertyStatus());
        // statusResult.data should include active_property boolean
        if (statusResult && statusResult.success) {
          if (statusResult.data && statusResult.data.active_property) {
            history("/dashboard");
          } else {
            // no active property yet – send user to onboarding with resume info
            const pendingId = statusResult.data?.pending_property?.id;
            if (pendingId) {
              history(`/onboarding?propertyId=${pendingId}`);
            } else {
              history("/onboarding");
            }
          }
        } else {
          // fallback to dashboard if API call failed
          history("/dashboard");
        }
      } catch (err) {
        // if checking status throws, just go to dashboard
        history("/dashboard");
      }

      return response;
    } else if (response?.status === "pending") {
      const msg = response.error || "Account is not approved yet. Please wait for admin approval.";
      dispatch(apiError({ data: msg }));
      return { isPending: true, status: "pending", message: msg };
    } else {
      const errorMessage = response?.message || response?.error || "Login failed";
      dispatch(apiError({ data: errorMessage }));
      return response;
    }
  } catch (error: any) {
    // API rejects with response.data directly (see api_helper interceptor)
    // so error IS the body: {"error":"Account is not approved yet","status":"pending"}
    console.log("[loginUser] catch error:", JSON.stringify(error))
    if (error?.status === "pending") {
      const msg = error.error || "Account is not approved yet. Please wait for admin approval.";
      dispatch(apiError({ data: msg }));
      return { isPending: true, status: "pending", message: msg };
    }

    const errorResponse = error?.response?.data || {
      success: false,
      message: error?.message || "An error occurred during login. Please try again.",
    };
    dispatch(apiError({ data: errorResponse.message }));
    return errorResponse;
  }
};

export const loginAffiliateUser = (user: any, history: any, rememberMe: boolean = false) => async (dispatch: any) => {
  dispatch(loginRequest());

  try {
    const response = await postAffiliateLogin({
      email: user.email,
      password: user.password,
    });

    const token = response?.token || response?.data?.token;
    if (response?.success && token) {
      const tokenPayload = { ...(response.data ?? response), user_type: 'affiliate' };
      TokenManager.setTokens(tokenPayload, rememberMe);
      setAuthorization(token);
      dispatch(loginSuccess(tokenPayload));
      return { success: true, message: response.message };
    } else {
      const errorMessage = response?.message || response?.error || "Login failed";
      dispatch(apiError({ data: errorMessage }));
      return { success: false, message: errorMessage };
    }
  } catch (error: any) {
    const errorResponse = error?.response?.data || {
      success: false,
      message: error?.message || "An error occurred during login. Please try again.",
    };
    dispatch(apiError({ data: errorResponse.message }));
    return { success: false, ...errorResponse };
  }
};

export const logoutUser = () => async (dispatch: any) => {
  try {
    TokenManager.clearTokens();
    dispatch(logoutUserSuccess(true));
  } catch (error) {
    dispatch(apiError(error));
  }
};



export const resetLoginFlag = () => async (dispatch: any) => {
  try {
    const response = dispatch(reset_login_flag());
    return response;
  } catch (error) {
    dispatch(apiError(error));
  }
};